import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const services = [
  {
    icon: 'ri-draft-line',
    title: 'Keşif ve Proje Hizmetleri',
    description:
      'Uzman ekibimiz mekanınızı detaylı şekilde inceler, risk analizi yapar ve ihtiyaçlarınıza özel yangın güvenlik projesi hazırlar.',
    link: '/hizmetler#kesif-projelendirme',
    stats: '450+ Proje',
  },
  {
    icon: 'ri-tools-line',
    title: 'Kurulum ve Destek Hizmetleri',
    description:
      'Sertifikalı teknisyenlerimiz yangın algılama sistemlerini profesyonel şekilde kurar ve devreye alır. Tüm süreçte kalite kontrol garantisi.',
    link: '/hizmetler#kurulum-destek',
    stats: '1200+ Kurulum',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Bakım ve Destek Hizmetleri',
    description:
      'Sistemlerinizin sürekli çalışır durumda kalması için periyodik bakım ve 7/24 teknik destek hizmeti. Acil durumlarda anında müdahale.',
    link: '/hizmetler#bakim-destek',
    stats: '2350+ Müşteri',
  },
];

export default function ServicesOverview() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-semibold text-red-600 tracking-wider uppercase">
            Hizmetlerimiz
          </span>
          <h4 className="text-3xl lg:text-4xl font-bold text-gray-900 mt-3 mb-4">
            <Link
              to="/hizmetler"
              className="hover:text-red-600 transition-colors cursor-pointer"
            >
              Kapsamlı Yangın Güvenlik Çözümleri
            </Link>
          </h4>
          <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Yangın algılama, duman sensörleri ve alarm sistemleri ile işletmenizi ve yaşam alanlarınızı koruma altına alıyoruz.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15, duration: 0.5 }}
            >
              <Link
                to={service.link}
                className="group block bg-white border border-gray-100 rounded-2xl p-8 hover:shadow-xl hover:border-red-100 transition-all duration-300 cursor-pointer h-full"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-red-50 rounded-xl mb-6 group-hover:bg-red-600 transition-colors duration-300">
                  <i
                    className={`${service.icon} text-2xl text-red-600 group-hover:text-white transition-colors duration-300`}
                  ></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-5">
                  {service.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs font-semibold text-red-600 bg-red-50 px-3 py-1 rounded-full">
                    {service.stats}
                  </span>
                  <span className="text-sm font-medium text-red-600 inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                    Detay <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="text-center mt-12"
        >
          <Link
            to="/hizmetler"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gray-900 text-white font-semibold rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Tüm Hizmetleri Görüntüle
            <i className="ri-arrow-right-line"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
